import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import { returnBlockValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const HeaderBlock = ({ id, block, design, content, index }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div
      className={Classnames('opr-header', {
        'pt-8': index !== 0,
      })}
    >
      <div
        className={Classnames('', {
          'border-l-4 pl-5 py-3':
            returnBlockValue(
              'bordertoggle',
              'design',
              opBlocks[block],
              design
            ) == 'showborder',
        })}
        style={{
          borderColor: returnBlockValue(
            'bordercolor',
            'design',
            opBlocks[block],
            design
          ),
        }}
      >
        <h1
          className={Classnames('font-bold', {
            'text-lg':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == 'default',
            'text-xl':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == 'xl',
            'text-2xl':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == '2xl',
          })}
        >
          {returnBlockValue('headline', 'content', opBlocks[block], content)}
        </h1>
        <h3 className="opacity-70 mt-0 text-md">
          {returnBlockValue('subheadline', 'content', opBlocks[block], content)}
        </h3>
      </div>
    </div>
  )
}

export default HeaderBlock
